export default __webpack_public_path__ + "static/media/blue.f7e46052.png";